import "core-js/modules/es.array.push.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-4c0395b4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "position": "relative",
    "top": "0",
    "left": "0",
    "margin-bottom": "20px",
    "z-index": "3",
    "width": "100%",
    "padding": "0 10px"
  }
};
const _hoisted_2 = {
  class: "balance-urrency",
  style: {
    "z-index": "3",
    "position": "relative",
    "height": "100%"
  }
};
const _hoisted_3 = {
  class: "header"
};
const _hoisted_4 = {
  class: "name"
};
const _hoisted_5 = {
  class: "data-list"
};
const _hoisted_6 = {
  class: "data-item"
};
const _hoisted_7 = {
  class: "label"
};
const _hoisted_8 = {
  class: "num"
};
const _hoisted_9 = {
  class: "data-item data-center"
};
const _hoisted_10 = {
  class: "label"
};
const _hoisted_11 = {
  class: "num"
};
const _hoisted_12 = {
  class: "data-item data-right"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "USDT", -1));

const _hoisted_14 = {
  class: "num"
};
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  key: 1
};
const _hoisted_17 = {
  key: 0
};
const _hoisted_18 = {
  key: 1
};
const _hoisted_19 = {
  key: 0,
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center",
    "width": "100%",
    "padding-top": "10px"
  }
};
const _hoisted_20 = {
  class: "balance-urrency",
  style: {
    "position": "absolute",
    "top": "6px",
    "left": "5%",
    "z-index": "2",
    "width": "90%",
    "background-color": "var(--gray-color)",
    "opacity": "0.15"
  }
};
const _hoisted_21 = {
  class: "header"
};
const _hoisted_22 = {
  class: "name"
};
const _hoisted_23 = {
  class: "data-list"
};
const _hoisted_24 = {
  class: "data-item"
};
const _hoisted_25 = {
  class: "label"
};
const _hoisted_26 = {
  class: "num"
};
const _hoisted_27 = {
  class: "data-item data-center"
};
const _hoisted_28 = {
  class: "label"
};
const _hoisted_29 = {
  class: "num"
};
const _hoisted_30 = {
  class: "data-item data-right"
};

const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "USDT", -1));

const _hoisted_32 = {
  class: "num"
};
const _hoisted_33 = {
  key: 0
};
const _hoisted_34 = {
  key: 1
};
const _hoisted_35 = {
  key: 0
};
const _hoisted_36 = {
  key: 1
};
const _hoisted_37 = {
  key: 0,
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center",
    "width": "100%",
    "padding-top": "10px"
  }
};
const _hoisted_38 = {
  class: "balance-urrency",
  style: {
    "position": "absolute",
    "top": "13px",
    "left": "7.5%",
    "z-index": "1",
    "width": "85%",
    "background-color": "var(--gray-color)",
    "opacity": "0.1"
  }
};
const _hoisted_39 = {
  class: "header"
};
const _hoisted_40 = {
  class: "name"
};
const _hoisted_41 = {
  class: "data-list"
};
const _hoisted_42 = {
  class: "data-item"
};
const _hoisted_43 = {
  class: "label"
};
const _hoisted_44 = {
  class: "num"
};
const _hoisted_45 = {
  class: "data-item data-center"
};
const _hoisted_46 = {
  class: "label"
};
const _hoisted_47 = {
  class: "num"
};
const _hoisted_48 = {
  class: "data-item data-right"
};

const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "USDT", -1));

const _hoisted_50 = {
  class: "num"
};
const _hoisted_51 = {
  key: 0
};
const _hoisted_52 = {
  key: 1
};
const _hoisted_53 = {
  key: 0
};
const _hoisted_54 = {
  key: 1
};
const _hoisted_55 = {
  key: 0,
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center",
    "width": "100%",
    "padding-top": "10px"
  }
};
import router from '@/router';
import store from '@/store';
import { fmtImageSrc } from '@/util';
import { useI18n } from "vue-i18n";
import { fmtNumber } from '@/util';
export default {
  __name: 'BalanceCurrency',
  props: {
    arrowShow: {
      type: Boolean,
      default: true
    },
    active: {
      type: Number,
      default: 0
    },
    freeze: {
      type: Number,
      default: 0
    },
    folded: {
      type: Number,
      default: 0
    },
    icon: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: '--'
    },
    symbol: {
      type: String,
      default: '--'
    },
    btn: {
      type: Boolean,
      default: false
    }
  },

  setup(__props) {
    const props = __props;
    const {
      t
    } = useI18n();

    const getBtnStyle = width => {
      return {
        '--van-button-border-radius': '2px',
        width: width,
        '--van-button-default-height': '32px',
        fontSize: '13px'
      };
    };

    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");

      const _component_van_icon = _resolveComponent("van-icon");

      const _component_van_button = _resolveComponent("van-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_van_image, {
        src: _unref(fmtImageSrc)(props.icon),
        width: "25",
        height: "25",
        round: "",
        style: {
          "margin-right": "10px"
        }
      }, null, 8, ["src"]), _createElementVNode("span", null, _toDisplayString(props.name), 1)]), props.arrowShow ? (_openBlock(), _createBlock(_component_van_icon, {
        key: 0,
        name: "arrow",
        size: "17px",
        color: "#969799"
      })) : _createCommentVNode("", true), props.btn && props.name !== 'BTC' && props.name !== 'USDT' && props.name !== 'ETH' && props.name !== 'USDC' ? (_openBlock(), _createBlock(_component_van_button, {
        key: 1,
        color: "#5bbc51",
        style: {
          "--van-button-default-height": "30px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('balanceText')), 1)]),
        _: 1
      })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('useable')), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(fmtNumber)(props.active)), 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('freeze')), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(fmtNumber)(props.freeze)), 1)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [props.name == 'USDT' ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(props.folded), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_16, [Number.isNaN(props.folded * _unref(store).state.market[props.symbol]?.last) || !Number.isFinite(props.folded * _unref(store).state.market[props.symbol]?.last) ? (_openBlock(), _createElementBlock("span", _hoisted_17, "0")) : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString((props.folded * _unref(store).state.market[props.symbol]?.last).toFixed(6)), 1))]))])])]), props.btn && (props.name === 'BTC' || props.name === 'USDT' || props.name === 'ETH' || props.name === 'USDC') ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_van_button, {
        color: "#5bbc51",
        block: "",
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => _unref(router).push({
          name: 'recharge',
          query: {
            type: props.name
          }
        }), ["stop"])),
        style: _normalizeStyle(getBtnStyle('32%'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('recharge')), 1)]),
        _: 1
      }, 8, ["style"]), _createVNode(_component_van_button, {
        color: "white",
        block: "",
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => _unref(router).push({
          name: 'withdraw',
          query: {
            type: props.name
          }
        }), ["stop"])),
        style: _normalizeStyle([{
          "color": "white",
          "background-color": "#707A8A"
        }, getBtnStyle('32%')])
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('withdraw')), 1)]),
        _: 1
      }, 8, ["style"]), _createVNode(_component_van_button, {
        color: "white",
        block: "",
        style: _normalizeStyle([getBtnStyle('32%'), {
          "color": "white",
          "background-color": "#707A8A"
        }])
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('balanceText')), 1)]),
        _: 1
      }, 8, ["style"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_van_image, {
        src: _unref(fmtImageSrc)(props.icon),
        width: "25",
        height: "25",
        round: "",
        style: {
          "margin-right": "10px"
        }
      }, null, 8, ["src"]), _createElementVNode("span", null, _toDisplayString(props.name), 1)]), props.arrowShow ? (_openBlock(), _createBlock(_component_van_icon, {
        key: 0,
        name: "arrow",
        size: "17px",
        color: "#969799"
      })) : _createCommentVNode("", true), props.btn && props.name !== 'BTC' && props.name !== 'USDT' && props.name !== 'ETH' && props.name !== 'USDC' ? (_openBlock(), _createBlock(_component_van_button, {
        key: 1,
        color: "#5bbc51",
        style: {
          "--van-button-default-height": "30px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('balanceText')), 1)]),
        _: 1
      })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString(_unref(t)('useable')), 1), _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(fmtNumber)(props.active)), 1)]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, _toDisplayString(_unref(t)('freeze')), 1), _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(fmtNumber)(props.freeze)), 1)]), _createElementVNode("div", _hoisted_30, [_hoisted_31, _createElementVNode("div", _hoisted_32, [props.name == 'USDT' ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(props.folded), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_34, [Number.isNaN(props.folded * _unref(store).state.market[props.symbol]?.last) || !Number.isFinite(props.folded * _unref(store).state.market[props.symbol]?.last) ? (_openBlock(), _createElementBlock("span", _hoisted_35, "0")) : (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString((props.folded * _unref(store).state.market[props.symbol]?.last).toFixed(6)), 1))]))])])]), props.btn && (props.name === 'BTC' || props.name === 'USDT' || props.name === 'ETH' || props.name === 'USDC') ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createVNode(_component_van_button, {
        color: "#5bbc51",
        block: "",
        onClick: _cache[2] || (_cache[2] = _withModifiers($event => _unref(router).push({
          name: 'recharge',
          query: {
            type: props.name
          }
        }), ["stop"])),
        style: _normalizeStyle(getBtnStyle('32%'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('recharge')), 1)]),
        _: 1
      }, 8, ["style"]), _createVNode(_component_van_button, {
        color: "white",
        block: "",
        onClick: _cache[3] || (_cache[3] = _withModifiers($event => _unref(router).push({
          name: 'withdraw',
          query: {
            type: props.name
          }
        }), ["stop"])),
        style: _normalizeStyle([{
          "color": "white",
          "background-color": "#707A8A"
        }, getBtnStyle('32%')])
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('withdraw')), 1)]),
        _: 1
      }, 8, ["style"]), _createVNode(_component_van_button, {
        color: "white",
        block: "",
        style: _normalizeStyle([getBtnStyle('32%'), {
          "color": "white",
          "background-color": "#707A8A"
        }])
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('balanceText')), 1)]),
        _: 1
      }, 8, ["style"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createVNode(_component_van_image, {
        src: _unref(fmtImageSrc)(props.icon),
        width: "25",
        height: "25",
        round: "",
        style: {
          "margin-right": "10px"
        }
      }, null, 8, ["src"]), _createElementVNode("span", null, _toDisplayString(props.name), 1)]), props.arrowShow ? (_openBlock(), _createBlock(_component_van_icon, {
        key: 0,
        name: "arrow",
        size: "17px",
        color: "#969799"
      })) : _createCommentVNode("", true), props.btn && props.name !== 'BTC' && props.name !== 'USDT' && props.name !== 'ETH' && props.name !== 'USDC' ? (_openBlock(), _createBlock(_component_van_button, {
        key: 1,
        color: "#5bbc51",
        style: {
          "--van-button-default-height": "30px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('balanceText')), 1)]),
        _: 1
      })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, _toDisplayString(_unref(t)('useable')), 1), _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(fmtNumber)(props.active)), 1)]), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, _toDisplayString(_unref(t)('freeze')), 1), _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(fmtNumber)(props.freeze)), 1)]), _createElementVNode("div", _hoisted_48, [_hoisted_49, _createElementVNode("div", _hoisted_50, [props.name == 'USDT' ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(props.folded), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_52, [Number.isNaN(props.folded * _unref(store).state.market[props.symbol]?.last) || !Number.isFinite(props.folded * _unref(store).state.market[props.symbol]?.last) ? (_openBlock(), _createElementBlock("span", _hoisted_53, "0")) : (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString((props.folded * _unref(store).state.market[props.symbol]?.last).toFixed(6)), 1))]))])])]), props.btn && (props.name === 'BTC' || props.name === 'USDT' || props.name === 'ETH' || props.name === 'USDC') ? (_openBlock(), _createElementBlock("div", _hoisted_55, [_createVNode(_component_van_button, {
        color: "#5bbc51",
        block: "",
        onClick: _cache[4] || (_cache[4] = _withModifiers($event => _unref(router).push({
          name: 'recharge',
          query: {
            type: props.name
          }
        }), ["stop"])),
        style: _normalizeStyle(getBtnStyle('32%'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('recharge')), 1)]),
        _: 1
      }, 8, ["style"]), _createVNode(_component_van_button, {
        color: "white",
        block: "",
        onClick: _cache[5] || (_cache[5] = _withModifiers($event => _unref(router).push({
          name: 'withdraw',
          query: {
            type: props.name
          }
        }), ["stop"])),
        style: _normalizeStyle([{
          "color": "white",
          "background-color": "#707A8A"
        }, getBtnStyle('32%')])
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('withdraw')), 1)]),
        _: 1
      }, 8, ["style"]), _createVNode(_component_van_button, {
        color: "white",
        block: "",
        style: _normalizeStyle([getBtnStyle('32%'), {
          "color": "white",
          "background-color": "#707A8A"
        }])
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('balanceText')), 1)]),
        _: 1
      }, 8, ["style"])])) : _createCommentVNode("", true)])]);
    };
  }

};